module.exports = __webpack_public_path__ + "img/6.73247b1f.jpeg";